import { useTranslation } from 'react-i18next';
import { FEATURES } from 'consts';
import noop from 'lodash/noop';
import { selectIsMeRecordingInitiator, selectIsRecording } from 'state/selectors';
import { ShapeVariant, SizeVariant } from 'ui/components/ControlButton/types';
import { isFeatureOn } from 'useCase/featureFlags/featureFlagsApi';
import { RecordProgressData } from './RecordProgressData';
import { RecordInProgressButtonBase, RecordInProgressIcon } from './view';

interface RecordInProgressButtonProps {
    onClick(): void;
    disabled?: boolean;
    buttonShape?: ShapeVariant;
    buttonSize?: SizeVariant;
}

export const RecordInProgressButton = ({
    onClick,
    disabled = false,
    buttonShape,
    buttonSize,
}: RecordInProgressButtonProps) => {
    const { t } = useTranslation();
    const isRecording = isFeatureOn(FEATURES.VCS_RECORDING_ENABLED) && selectIsRecording();
    const isMeRecordingInitiator = selectIsMeRecordingInitiator();
    const isStopRecordDisabled = disabled || !isMeRecordingInitiator;
    const isRecordingByNotByMe = !disabled && isRecording && !isMeRecordingInitiator;

    let title = '';
    if (isRecordingByNotByMe) {
        title = t('web_call_record_tooltip_video_stop_initiator');
    } else if (isRecording) {
        title = t('web_call_record_tooltip_video_stop');
    }

    return (
        <RecordInProgressButtonBase
            title={title}
            disabled={isStopRecordDisabled}
            onClick={disabled ? noop : onClick}
            shape={buttonShape}
            size={buttonSize}
        >
            <RecordInProgressIcon icon="icStopRecording" color="none" size={24} />
            <RecordProgressData buttonSize={buttonSize} />
        </RecordInProgressButtonBase>
    );
};
